import { createSelector, createSlice } from "@reduxjs/toolkit";

const logsSlice = createSlice({
    name: "logs",
    initialState: {
        userDisabledLogs: [],

    },
    reducers: {
        fetchUserLogs: () => { },
        storeUserLogs: (state, action) => {
            state.userDisabledLogs = action.payload
        }
    }
})



export const { fetchUserLogs, storeUserLogs } = logsSlice.actions;

export const logsSelector = createSelector(
    state => state.logs,
    logs => logs
);


export default logsSlice.reducer;